// extracted by mini-css-extract-plugin
module.exports = {"action":"Icecream_action__jaMkL","demand":"Icecream_demand__2K4Dp","highlight":"Icecream_highlight__VqZ-c","rate":"Icecream_rate__2mVUn"};